<template>
  <div class="header_content">
    <div class="header_container">
      <div class="md_top">
        <div class="sm_top">
          <div class="share_preivous">
            <div
              @click="openModalShare('Compartilhe este leilão em suas redes', leilao.nm, leilao.descricao, getLink() )"
              class="share_leilao"
            >
              <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                      d="M12.8571 6.28571C14.5929 6.28571 16 4.87861 16 3.14286C16 1.40711 14.5929 0 12.8571 0C11.1214 0 9.71429 1.40711 9.71429 3.14286C9.71429 3.19283 9.71545 3.24254 9.71776 3.29194L5.14577 5.57793C4.60195 5.12771 3.904 4.85714 3.14286 4.85714C1.40711 4.85714 0 6.26425 0 8C0 9.73575 1.40711 11.1429 3.14286 11.1429C3.904 11.1429 4.60195 10.8723 5.14577 10.4221L9.71776 12.7081C9.71545 12.7575 9.71429 12.8072 9.71429 12.8571C9.71429 14.5929 11.1214 16 12.8571 16C14.5929 16 16 14.5929 16 12.8571C16 11.1214 14.5929 9.71429 12.8571 9.71429C11.9974 9.71429 11.2181 10.0596 10.6507 10.619L6.25757 8.42246C6.27613 8.28429 6.28571 8.14326 6.28571 8C6.28571 7.85674 6.27613 7.71571 6.25757 7.57754L10.6507 5.38097C11.2181 5.94043 11.9974 6.28571 12.8571 6.28571Z"
                      fill="white"/>
              </svg>
            </div>
            <div @click="previous()" class="previous_leilao">
              <svg width="10" height="12" viewBox="0 0 10 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M9.16738 10.2939C9.16788 10.4738 9.11988 10.6505 9.02838 10.8054C8.93678 10.9603 8.80518 11.0876 8.64738 11.1739C8.49538 11.2617 8.32298 11.3079 8.14738 11.3079C7.97188 11.3079 7.79948 11.2617 7.64738 11.1739L0.45742 6.47397C0.31707 6.38332 0.20167 6.25894 0.12177 6.1122C0.0418699 5.96547 0 5.80105 0 5.63397C0 5.46689 0.0418699 5.30247 0.12177 5.15574C0.20167 5.009 0.31707 4.88463 0.45742 4.79397L7.66738 0.13397C7.81948 0.0462 7.99188 0 8.16738 0C8.34298 0 8.51538 0.0462 8.66738 0.13397C8.82528 0.22032 8.95678 0.34764 9.04838 0.50251C9.13988 0.65739 9.18788 0.83408 9.18738 1.01397L9.16738 10.2939Z"
                  fill="white"/>
              </svg>
            </div>
          </div>
          <div class="divider"></div>
          <div class="logo_content">
            <div class="logo_leilao">
              <img v-if="leilao.comitente" :src="leilao.comitente.nm_pathlogo"/>
            </div>
          </div>
          <div class="divider sm_none"></div>
        </div>
        <div class="infos_leilao">
          <div class="status_id_habilitados">
            <span class="status_leilao_montagem" :class="montagembg">{{ montagem }}</span>
            <span class="status_leilao_id">Leilão ID: {{ leilaoid }}</span>
            <div class="status_leilao_habilitados">habilitados<span
              class="leilao_habilitados">{{ leilao.nu_qtdeliberados }}</span></div>
          </div>
          <div class="titulo_leilao">
            <span class="font-new">{{ titulo }}</span>
          </div>
          <div v-if="![2, 6, 18].includes(leilao.statusleilao_id)" class="nm_local">
            <span class="tw-font-bold">Local:</span>
            <span>{{ leilao.nm_local }}</span>
          </div>
        </div>
      </div>
      <div class="divider md_none"></div>
      <div class="md_bottom">
        <div class="modal_condicao_informacao">
          <div @click="openModalCondicoes"
               :class="this.liberado ? 'modal_condicao_habilitado' : 'modal_condicao'">
            <span class="label_habilitacao">{{ this.liberado ? 'habilitado' : 'habilite-se' }}</span>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M0 1.49927C0 0.678495 0.67943 -0.000228882 1.5 -0.000228882H12.5C13.3206 -0.000228882 14 0.678496 14 1.49927V4.35336C14 8.48877 11.4901 12.3594 7.58873 13.8809C7.41772 13.9476 7.21478 14.0013 6.99302 14.0002C6.77602 13.9992 6.57792 13.9459 6.41127 13.8809C2.50995 12.3594 0 8.48877 0 4.35336V1.49927ZM10.5606 4.5083C10.8358 4.19872 10.8079 3.72466 10.4983 3.44947C10.1887 3.17428 9.71469 3.20217 9.4395 3.51176L5.89798 7.49597L4.45006 6.41003C4.11869 6.1615 3.64859 6.22866 3.40006 6.56003C3.15153 6.8914 3.21869 7.3615 3.55006 7.61003L5.55006 9.11003C5.86211 9.34407 6.30147 9.29984 6.56062 9.0083L10.5606 4.5083Z"
                    fill="white"/>
            </svg>
          </div>
          <span @click="openModalInformacoes" class="modal_informacao">condições de venda</span>
          <div v-if="leilao.anexos && leilao.anexos.length > 0" @click="openModalAnexos" class="modal_anexos">
            <div class="">
              <span>anexos</span>
              <i class="icon-attachment"></i></div>
          </div>
        </div>
        <div class="divider"></div>

        <div class="qtde_lotes_estados">
          <div class="qtde_lotes">
            <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd"
                    d="M7.18423 0.454387C7.06722 0.397966 6.93287 0.397966 6.81587 0.454387L4.4852 1.57821L6.99837 2.79004L9.51322 1.57741L7.18423 0.454387ZM4.06597 5.28447V2.41032L6.55393 3.61V6.78697L4.32622 5.71279C4.16771 5.63635 4.06597 5.46891 4.06597 5.28447ZM7.44282 11.6026V8.4585L9.80078 9.59546V12.7725L7.57311 11.6984C7.52372 11.6745 7.47983 11.6419 7.44282 11.6026ZM10.6897 12.7741V9.59546L13.181 8.39422V11.27C13.181 11.4545 13.0793 11.6219 12.9208 11.6984L10.6897 12.7741ZM6.55393 8.45844V11.606C6.51761 11.6438 6.47484 11.6752 6.42687 11.6984L4.19582 12.7741V9.59546L6.55393 8.45844ZM3.30694 9.59546V12.7725L1.07923 11.6984C0.920713 11.6219 0.81897 11.4545 0.81897 11.27V8.39583L3.30694 9.59546ZM7.44282 6.78858V3.61L9.93412 2.40871V5.28447C9.93412 5.46891 9.83243 5.63635 9.67385 5.71279L7.44282 6.78858ZM10.0627 6.43992C10.1797 6.3835 10.3141 6.3835 10.4311 6.43992L12.7601 7.56292L10.2452 8.77554L7.73211 7.56372L10.0627 6.43992ZM3.56887 6.43992C3.68588 6.3835 3.82023 6.3835 3.93724 6.43992L6.2662 7.56292L3.75138 8.77554L1.23824 7.56372L3.56887 6.43992Z"
                    fill="#7A7A7A"/>
            </svg>
            <span class="label_estados">{{ leilao.nu_qtdelotes }} Lote(s)</span>
          </div>
          <div v-if="leilao" class="grid_estado">
            <div v-for="(estado, index) in getEstadosLotes(leilao)"
                 :key="estado"
                 @mouseover="estado.includes('+') && showRemainingStates()"
                 @mouseleave="hideRemainingStates()">
              <span class="estado">{{ estado }}</span>
            </div>
            <!-- Tooltip que aparece ao passar o mouse -->
            <div v-if="showTooltip" class="tooltip_estados">
              <span v-for="estado in remainingStates" :key="estado">{{ estado }}</span>
            </div>
          </div>
        </div>
        <div class="divider"></div>
        <div class="leilao_datas" v-if="leilao.datas && leilao.datas.length > 0">
          <div id="dateContainer">
            <div class="max-content">
              <div
                v-for="(data, index) in leilao.datas"
                :key="index"
                class="status_data"
              >
                <div class="statusrotuloleilao">
                  <i class="icon-calendar"></i>
                  <span v-if="!(leilao.statusleilao_id === 13)">
                    {{ index + 1 }}º {{ leilao.statusrotuloleilao_primeiro }} -
                  </span>
                  <span v-else>{{ index + 1 }}º Leilão -</span>
                </div>
                <div class="data_hora_leilao">
                  <div class="date-data">
                    <span class="data_local"></span>{{ formatDate(data.dt, 'd') }}
                  </div>
                  <div class="date-time">
                    <i class="icon-time"></i>
                    <span class="hora_local">{{ formatDate(data.dt, 'h') }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="leilao_datas">
          <div id="dateContainer">
            <div class="max-content">
              <div class="status_data tw-font-bold tw-text-jrBlue-100">

                <div class="statusrotuloleilao">
                  <i class="icon-calendar"></i>
                  <span v-if="!(leilao.statusleilao_id !== 6 && leilao.statusleilao_id !== 2)">
                    {{ leilao.statusrotuloleilao_primeiro }} -
                  </span>
                  <span v-else>
                    {{ leilao.statusrotuloleilao_primeiro }} -
                  </span>
                </div>

                <div class="data_hora_leilao">
                  <div class="date-data">
                    <span class="data_local"></span>{{ leilao.dt_formatada }}
                  </div>
                  <div class="date-time">
                    <i class="icon-time"></i>
                    <span class="hora_local">{{ leilao.hr_formatada }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <modal-share
        ref="modalShared"
        :header="shared.header"
        :title="shared.title"
        :description="shared.description"
        :url="shared.url"
      />
      <modal-anexos
        ref="modalAnexos"
        :leilao="leilao"
        :leiloeiro="leiloeiro"
      />
      <condicoes-venda
        ref="modalCondicoes"
        :leilao="leilao"
      />
      <informacoes
        ref="modalInformacoes"
        :leilao="leilao"
      />
    </div>
  </div>
</template>

<script>
import LeilaoSocial from "@/components/shared/social/LeilaoSocial.vue";
import ModalShare from "@/components/shared/ModalShare.vue";
import ModalAnexos from "@/components/shared/ModalAnexos.vue";
import CondicoesVenda from "./CondicoesVenda.vue";
import Informacoes from "./Informacoes.vue";

export default {
  name: "HeaderDisputa",
  components: {Informacoes, CondicoesVenda, ModalShare, ModalAnexos, LeilaoSocial},
  props: ["leilaoid", "lotes", "loteid", "lote", "dadosLeilao", "dadosModeradorId", 'liberado'],
  computed: {
    verificaData() {
      //Verificar a data do leilão para nao exibir mais o video
      var data_leilao = new Date(
        this.leilao.dt_formatado.replace(
          /^(\d{2})\/(\d{2})\/(\d{4})$/,
          "$3-$2-$1 00:01:00"
        )
      );
      if (this.leilao.dt_segundoleilao_data != undefined) {
        data_leilao = new Date(
          this.leilao.dt_segundoleilao_data.replace(
            /^(\d{2})\/(\d{2})\/(\d{4})$/,
            "$3-$2-$1 00:01:00"
          )
        );
      }
      var data_atual = new Date();

      if (data_atual < data_leilao) {
        return true;
      } else {
        return false;
      }
    },
    titulo() {

      const titulo = this.leilao.nm

      if (titulo)
        return titulo.split('|')[0]

      return titulo
    },
    subtitulo() {
      const titulo = this.leilao.nm
      if (titulo) {
        const subtitulo = titulo.split('|')
        if (subtitulo.length > 1)
          return subtitulo[1]
      }

      return ''
    },
    mainDomain() {
      const domainParts = window.location.hostname.split('.');
      return domainParts.length > 2 ? domainParts[1] : domainParts[0];
    },
  },
  data() {
    return {
      firstLoad: true,
      leilao_id: this.$route.params.id,
      leiloeiro: [],
      dados_condicao: [],
      leilao: [],
      usuario: [],
      estados: [],
      montagem: null,
      rotuloMontagem: 'Leilão',
      rotuloMontagemSegundo: 'Leilão',
      rotuloMontagemMultiplas: 'Leilão',
      montagembg: null,
      statusLeilao: null,
      statusLeilaoBg: null,
      message: "",
      liberado: false,
      informativo: false,
      message_informativo: "",
      exibe_video: false,
      countLote: null,
      nu_liberados: null,
      link_video: "",
      tipo_video: "",
      nomeLeiloeiro: "",
      leilaoModerador: 0,
      shared: {
        header: '',
        title: '',
        description: '',
        url: ''
      },
      remainingStates: [],
      showTooltip: false,
    };
  },
  methods: {
    formatDate(date, type) {
      if (typeof date === 'string') {
        const [dateString, timeString] = date.split(' ');

        switch (type) {
          case 'd':
            const [year, month, day] = dateString.split('-');
            return `${day}/${month}/${year}`;
          case 'h':
            const timeComponents = timeString.split(/[:\-]/);
            const hour = timeComponents[0];
            const minute = timeComponents[1];
            return `${hour.padStart(2, '0')}:${minute.padStart(2, '0')}`;
          default:
            return date;
        }
      } else if (date instanceof Date) {
        switch (type) {
          case 'd':
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${day}/${month}/${year}`;
          case 'h':
            const hour = String(date.getHours()).padStart(2, '0');
            const minute = String(date.getMinutes()).padStart(2, '0');
            return `${hour}:${minute}`;
          default:
            return date.toString();
        }
      } else {
        return date.toString();
      }
    },

    highlightAndScrollToDate() {
      this.$nextTick(() => {
        const dataAtual = new Date();

        for (let i = 0; i < this.leilao.datas.length; i++) {
          const data = this.leilao.datas[i];
          const dataLeilao = new Date(data.dt);

          if (dataAtual <= dataLeilao && this.leilao.statusmontagem_id !== 6) {
            const dateElement = this.$el.querySelectorAll(".status_data")[i];

            if (dateElement) {
              dateElement.scrollIntoView({behavior: "smooth", block: "center"});
              dateElement.classList.add("highlighted");
              break;
            }
          }
        }
      });
    },

    getEstadosLotes(leilao) {
      const estados = leilao.uf || [];
      if (estados.length > 9) {
        this.remainingStates = estados.slice(8);
        const remaining = estados.length - 8;
        return [...estados.slice(0, 8), `${remaining}+`];
      }
      this.remainingStates = [];
      return estados;
    },

    showRemainingStates() {
      this.showTooltip = true;
    },

    hideRemainingStates() {
      this.showTooltip = false;
    },

    extractText(content) {
      return $(content).text().toString();
    },

    openModalShare(header, title, description, url) {
      this.shared.header = header
      this.shared.title = title
      this.shared.description = description
      this.shared.url = url

      this.$refs.modalShared.modalToggle()
    },

    openModalAnexos() {
      this.$refs.modalAnexos.modalToggle()
    },

    openModalCondicoes() {
      this.$refs.modalCondicoes.modalToggle()
    },

    openModalInformacoes() {
      this.$refs.modalInformacoes.modalToggle()
    },

    previous() {
      const currentRoute = this.$route.path;
      const qtdeLotes = this.leilao.nu_qtdelotes;
      const leilaoPossuiLotes = qtdeLotes !== null && qtdeLotes !== undefined && qtdeLotes !== 0;
      const apenasUmLote = qtdeLotes === 1;

      if (!leilaoPossuiLotes || apenasUmLote) {
        window.location.href = window.location.origin;
      } else if (currentRoute.includes('/leilao/index/leilao_id/') && !currentRoute.includes('/lote/')) {
        window.location.href = window.location.origin;
      } else if (currentRoute.includes('/leilao/index/leilao_id/')) {
        const leilaoIdIndex = currentRoute.indexOf('/leilao_id/') + 11;
        const leilaoId = currentRoute.substring(leilaoIdIndex).split('/')[0];
        window.location.href = `/leilao/index/leilao_id/${leilaoId}`;
      } else {
        window.history.back();
      }
    },

    statusRotuloLeilao(status) {
      switch (Number(status)) {
        case 1:
          return "Abertura";
        case 2:
          return "Ciclo";
        case 3:
          return "Encerramento";
        case 4:
          return "Leilão";
        case 5:
          return "Praça";
        default:
          return "Leilão";
      }
    },

    formataLinkVideo(link) {
      if (link.search("youtube") > 0) {
        this.tipo_video = "youtube";
        return link.replace(/(.*?=)([\w-]+)&?(.*?)?$/g, "$2") + "?autoplay=1;";
      } else if (link.search("vimeo") > 0) {
        this.tipo_video = "vimeo";
        return link.replace(/(.*?)([\d]+)$/g, "$2");
      }
    },

    statusMontagem(status) {
      switch (Number(status)) {
        case 1:
          this.montagem = "Futuro";
          this.montagembg = "tw-bg-jrGreen-new";
          break;
        case 2:
          this.montagem = "Futuro";
          this.montagembg = "tw-bg-jrGreen-new";
          break;
        case 3:
          this.montagem = "Aberto para lances";
          this.montagembg = "tw-bg-jrGreen-new";
          break;
        case 7:
          this.montagem = "Futuro";
          this.montagembg = "tw-bg-jrGreen-new";
          break;
        case 4:
          this.montagem = "Cancelado";
          this.montagembg = "tw-bg-jrRed-50";
          break;
        case 5:
          this.montagem = "Suspenso";
          this.montagembg = "tw-bg-jrRed-50";
          break;
        case 6:
          this.montagem = "Finalizado";
          this.montagembg = "tw-bg-jrGray-250";
          break;
      }
    },

    statusLeilaoChange(status) {
      switch (Number(status)) {
        case 8:
        case 10:
        case 9:
          this.statusLeilao = "Físico";
          this.statusLeilaoBg = "fisico-nm-status";
          break;
        case 6:
        case 2:
          this.statusLeilao = "Online";
          this.statusLeilaoBg = "online-nm-status";
          break;
        case 1:
        case 3:
          this.statusLeilao = "Presencial";
          this.statusLeilaoBg = "presencial-nm-status";
          break;
        case 12:
        case 11:
        case 7:
        case 5:
          this.statusLeilao = "Justiça";
          this.statusLeilaoBg = "justica-nm-status";
          break;
      }
    },

    loadMsg() {
      var exibe_usuario_id = false;
      // VERIFICA STATUS MENSAGEM
      const tipoMsg = [
        {1: "Leilão presencial sem participação online."},
        {5: "Leilão suspenso"}
      ];

      tipoMsg.forEach(msgObj => {
        const statusId = Object.keys(msgObj)[0]; // Extrai o statusmontagem_id
        const message = msgObj[statusId]; // Extrai a mensagem correspondente

        if (this.leilao.statusmontagem_id == statusId) {
          this.message = message;
          return;
        }
      });
      if (this.usuario.id !== null) {
        exibe_usuario_id = true;
        if (this.usuario.statusliberacaoonline_id !== 3) {
          this.message = this.usuario.nm_statusliberacaomensagem;
        } else if (this.dados_condicao.aceitou_condicao == false) {
          this.message = `
                        <a style="margin-left: 10px;" title="Condições de Venda" href="javascript:void(0)">
                            Clique aqui para aceitar as condições de venda.
                        </a>
                    `;
        } else {
          this.message = this.usuario.nm_statusliberacaomensagem;
        }
      } else {
        this.message =
          "Usuário não logado, para iniciar os lances é preciso estar logado.";
      }

      if (this.leilao.bn_ocultaapelido == 1) {
        this.message_informativo =
          "Para este tipo de leilão o seu apelido ficará oculto.";
        if (exibe_usuario_id == true) {
          this.message_informativo +=
            " Seu código de identificação é: " + this.usuario.id;
        } else {
          this.message_informativo +=
            " Ao efetura login, seu código de idenfitificação aparecerá aqui!";
        }
        this.informativo = true;
      }

      this.msgEncerrado()
    },

    msgEncerrado() {
      if (this.leilaoModerador.leilao_id_segundoleilao > 0) {
        this.message_informativo =
          "<a href='/leilao/index/leilao_id/" +
          this.leilaoModerador.leilao_id_segundoleilao +
          "'>";
        this.message_informativo +=
          "Leilão encerrado, clique aqui para acessar o segundo leilão.";
        this.message_informativo += "</a>";
        this.informativo = true;
      }
    },

    getNomeLeiloeiro() {
      if (this.nomeLeiloeiro) {
        return this.nomeLeiloeiro;
      }
      if (this.lotes) {
        for (let lote of this.lotes) {
          let item = lote.fotos.find((e) => e.nm_path_completo);
          if (item) {
            this.nomeLeiloeiro = item.nm_path_completo.replace(
              /(.*public\/)(.*?)\/(.*)/,
              "$2"
            );
            return this.nomeLeiloeiro;
          }
        }
      }
    },

    getLink() {
      return window.location.href;
    },

    async showLeilao() {
      const hostName = location.protocol + "//" + window.HOSTNAME;
      const self = this;

      var loteid = self.loteid;

      await self.statusMontagem(self.leilao.statusmontagem_id);
      await self.statusLeilaoChange(self.leilao.statusleilao_id);

      if (loteid === undefined) {
        loteid = "";
      }

      await fetch(`${hostName}/leilao/get-dados-header-disputa?leilao_id=${self.leilaoid}&lote_id=${loteid}`)
        .then((res) => {
          if (!res.ok) {
            throw new Error(`HTTP error! Status: ${res.status}`);
          }
          return res.json();
        })
        .then((res) => {
          self.leiloeiro = res.config_leiloeiro;
          self.dados_condicao = res.dados_condicao;
          self.usuario = res.usuario;

          //Usuário com preferência.
          window.localStorage.setItem('a5cc51388b67c5c132389a6ffc950dbf', JSON.stringify(res.usuario_preferencia))
          self.loadMsg();

          self.$parent.$emit("dados-gerais", {
            config_leiloeiro: self.leiloeiro,
            dados_condicao: self.dados_condicao,
            usuario: self.usuario,
            vl_lanceautomatico: res.vl_lanceautomatico,
            navegacao: res.navegacao,
            thisHeaderDisputa: self,
            visitas: res.visitas,
          });
          self.$parent.$emit("liberacaoMensagem", {
            liberado: res.dados_condicao.aceitou_condicao,
            message: self.message,
            informativo: self.informativo,
            message_informativo: self.message_informativo,
            fechamento: self.leilao.bn_fechamentoautomatico,
            leilaoId: self.leilaoid,
            mostrarMesagem: true
          });
          sessionStorage.setItem(
            "isLogado",
            self.usuario.id !== null ? true : false
          );
        });
    },
  },

  created() {
    this.leilao = this.dadosLeilao;
    this.leilaoModerador = this.dadosModeradorId || 0;

    this.$parent.$on('statusloteClicado', () => this.showLeilao());
    this.$on('modalCondicoes', () => this.openModalCondicoes());
    this.$on('modalShared', (data) => {
      this.openModalShare(data.header, data.title, data.description, data.url);
    });
  },

  watch: {
    'leilao.datas': {
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.highlightAndScrollToDate();
        }
      },
      immediate: true
    },
    'dadosLeilao'(novo, ant) {
      this.leilao = this.dadosLeilao
      this.showLeilao()
    },
    'dadosModeradorId'(novo, ant) {
      this.leilaoModerador = this.dadosModeradorId || 0
      this.loadMsg()
      if (novo.leilao_id_segundoleilao) this.showLeilao()
    }
  },
};

function modalCondicoes() {
  console.log('OK')
}
</script>

<style scoped>
.header_container {
  display: flex;
  max-width: 1260px;
  padding: 20px;
  background-color: #fff;
  border-radius: 15px;
  gap: 8px;
  justify-content: space-between;
  min-height: 140px;
}

.divider {
  height: initial;
  border: 1px solid #eee;
}

.share_preivous {
  display: flex;
  flex-direction: column;
  justify-content: center;;
  gap: 20px;
  align-items: center;
}

.share_leilao, .previous_leilao {
  width: 30px;
  height: 30px;
  border-radius: 5px;
  padding: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.share_leilao {
  background-color: #7A7A7A;
}

.previous_leilao {
  background-color: #1C2D47;
}

.logo_content {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.logo_leilao {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0;
  width: 75px;
  height: 75px;
  border-radius: 10px;
}

.logo_leilao img {
  width: 75px;
  height: 75px;
  border-radius: 10px;
  object-fit: cover;
  display: block;
}

.infos_leilao {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.status_id_habilitados {
  display: flex;
  gap: 15px;
  align-items: center;
}

.status_leilao_montagem,
.status_leilao_id,
.leilao_habilitados {
  padding: 4px 9px;
  border-radius: 5px;
  color: #fff;
  font-size: 12px;
  font-weight: 700;
}

.status_leilao_id {
  background-color: #1C2D47;
  font-weight: 500;
}

.status_leilao_habilitados {
  display: flex;
  gap: 10px;
  align-items: center;
  color: #7A7A7A;
  font-weight: 600;
  font-size: 14px;
}

.leilao_habilitados {
  background-color: #7A7A7A;
}

.titulo_leilao {
  max-width: 400px;
  max-height: 58px;
  overflow-y: auto;
}

.titulo_leilao span {
  font-size: 16px;
  font-weight: 700;
}

.nm_local {
  max-width: 400px;
  font-size: 14px;
  margin-top: 10px;
}

.modal_condicao_informacao {
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 20px;
}

.modal_condicao {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  background-color: #1C2D47;
  color: #fff;
  cursor: pointer;
  transition: 0.3s ease;
}

.modal_condicao_habilitado {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  background-color: #7a9c60;
  color: #fff;
  cursor: pointer;
  transition: 0.3s ease;
}

.modal_anexos {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #cecece;
  color: #000;
  cursor: pointer;
  transition: 0.3s ease;
}

.modal_anexos:hover {
  background-color: #9b9b9b;
  color: #fff;
  transition: 0.3s ease;
}

.modal_informacao:hover {
  background-color: #314666;
  transition: 0.3s ease;
}

.modal_condicao:hover {
  background-color: #070d14;
  transition: 0.3s ease;
}

.modal_condicao_habilitado:hover {
  background-color: #407e3a;
  transition: 0.3s ease;
}

.modal_anexos div {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
}

.modal_condicao,
.modal_condicao_habilitado,
.modal_informacao,
.modal_anexos {
  font-size: 12px;
  padding: 6px 12px;
  border-radius: 5px;
}

.modal_informacao {
  background-color: #4A6A9A;
  color: #fff;
  font-weight: 500;
  cursor: pointer;
  transition: 0.3s ease;
  animation: blink 1s ease-in-out infinite;
}

@keyframes blink {
  0% {
    background-color: #6e9ee6
  }
  50% {
    background-color: #4A6A9A
  }
  100% {
    background-color: #6e9ee6
  }
}

.qtde_lotes_estados {
  width: 108px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  justify-content: center;
}

.qtde_lotes {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.label_estados,
.estado {
  color: #7a7a7a;
  font-size: 12px;
}

.grid_estado {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 5px;
}

.estado {
  border: 1px solid #C1C1C1;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  border-radius: 2px;
  user-select: none;
}

.leilao_datas {
  display: flex;
  align-items: center;
  height: 100%;
}

#dateContainer {
  width: 299px;
  background-color: #D0D0D0;
  border-radius: 10px;
  overflow-x: auto;
  padding: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

.max-content {
  max-height: 65px;
  width: 100%;
  overflow-y: auto;
  gap: 5px;
  display: flex;
  flex-direction: column;
}

.max-content::-webkit-scrollbar,
.titulo_leilao::-webkit-scrollbar {
  width: 9px;
}

.max-content::-webkit-scrollbar-track,
.titulo_leilao::-webkit-scrollbar-track {
  background: #fff;
  border-radius: 10px;
}

.max-content::-webkit-scrollbar-thumb,
.titulo_leilao::-webkit-scrollbar-thumb {
  background-color: #8F8F8F;
  border-radius: 20px;
  border: 3px solid #fff;
}

.status_data {
  color: #8F8F8F;
  font-size: 12px;
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  gap: 5px;
}

.highlighted {
  color: #1c2d47;
  font-weight: bold;
  transition: background-color 0.5s ease;
}

.data_hora_leilao {
  display: flex;
  justify-content: space-between;
  gap: 5px;
}

.date-time {
  display: flex;
  gap: 5px;
  align-items: center;
}

.tooltip_estados {
  position: absolute;
  background-color: rgba(0, 0, 0, .6);
  box-shadow: 0 2px 8px rgba(0, 0, 0, .15);
  color: #fff;
  border-radius: 2px;
  white-space: nowrap;
  z-index: 100;
  top: 250px;
  display: grid;
  grid-template-columns: repeat(4, auto);
  font-size: 12px;
  font-weight: 700;
}

.tooltip_estados span {
  border: 1px solid #fff;
  white-space: nowrap;
  margin: 5px;
  border-radius: 2px;
  padding: 0 8px;
}

.statusrotuloleilao {
  display: flex;
  align-items: center;
  gap: 5px;
}

.md_top,
.md_bottom,
.sm_top {
  display: flex;
  justify-content: space-between;
  gap: 8px;
}

@media (min-width: 1024px) {
  .md_top,
  .md_bottom,
  .sm_top {
    gap: 8px;
  }
}

@media (min-width: 1366px) {
  .md_top,
  .md_bottom,
  .sm_top {
    gap: 15px;
  }
}

@media (max-width: 1024px) {
  .nm_local {
    max-width: 447px;
  }

  .header_content {
    width: 100%;
    display: flex;
    justify-content: center;
  }

  .header_container {
    flex-direction: column;
    width: fit-content;
  }

  .md_top,
  .md_bottom {
    justify-content: space-between;
  }

  .md_none {
    display: none;
  }

  .infos_leilao {
    width: 100%;
  }

  .status_id_habilitados {
    justify-content: space-between;
  }

  .titulo_leilao {
    max-width: 447px;
  }

  .tooltip_estados {
    top: 350px;
  }
}

@media (max-width: 435px) {
  .md_top,
  .md_bottom {
    flex-direction: column;
  }

  #dateContainer {
    width: 321px;
  }

  .qtde_lotes_estados {
    gap: 10px;
    width: 100%;
  }

  .qtde_lotes {
    justify-content: center;
    gap: 5px;
  }

  .infos_leilao {
    gap: 10px;
  }

  .status_id_habilitados {
    flex-direction: column;
    gap: 10px;
  }

  .status_leilao_montagem,
  .status_leilao_id {
    width: 100%;
    text-align: center;
  }

  .modal_condicao_informacao {
    gap: 10px;
  }

  .modal_informacao {
    text-align: center;
  }

  .sm_none {
    display: none;
  }

  .sm_top {
    justify-content: initial;
  }

  .logo_content {
    width: 100%;
    justify-content: flex-end;
  }

  .logo_leilao,
  .logo_leilao img {
    width: 90px;
  }

  .tooltip_estados {
    top: 625px;
    right: 50px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/shared/HeaderDisputa.vue